import { ProductTier } from '@bonusly/who-am-i';

export enum CompanyStatus {
	InTrial = 'in_trial',
	Active = 'active',
	NonRenewing = 'non_renewing',
}
export interface Budget {
	display_unit: string;
	exchange_rate: number;
	format: {
		plural: string;
		singular: string;
	};
	has_custom_currency: boolean;
	iso_code: string;
	id: string;
	plural: string;
	singular: string;
}

export enum CatalogState {
	Active = 'active',
	Paused = 'paused',
	Shutoff = 'shutoff',
}

export interface CompanyProfile {
	id: string;
	budget: Budget;
	created_at: string;
	has_claimable_awards: boolean;
	hide_competitive_features: boolean;
	logo_url: string;
	monarch_cohort: string;
	name: string;
	status: CompanyStatus;
	trial_end_date: string;
	next_billing_at: string;
	updated_at: string;
}

export type AudienceOptions = {
	country?: any;
	department?: any;
	employment_type?: any;
	location?: any;
	role?: any;
};

export enum PromotedRewardsSetting {
	BonuslyPromoted = 'bonusly_promoted',
	CompanyPromoted = 'company_promoted',
	Disabled = 'disabled',
}

export interface Company {
	audience_options: AudienceOptions;
	axomo_subdomain?: string;
	bonus_privacy: boolean;
	budget: Budget;
	catalog_state: CatalogState;
	company_hashtags: string[];
	created_at: string;
	disable_gifs: boolean;
	disable_image_uploads: boolean;
	disable_video_recordings: boolean;
	disable_video_uploads: boolean;
	example_reason: string;
	give_amounts: number[];
	has_claimable_awards: boolean;
	hashtagging_mode: HashtaggingMode;
	hide_competitive_features: boolean;
	monarch_cohort: string;
	id: string;
	logo_url: string;
	name: string;
	promoted_rewards_setting: PromotedRewardsSetting;
	show_bonus_amounts: boolean;
	sign_up_company_size: number;
	status: CompanyStatus;
	suggested_hashtags: string[];
	subscription_days_past_due: number;
	zero_point_bonuses: boolean;
	trial_end_date: string;
	time_zone?: string;
	product_tier?: ProductTier;
}

export type HashtaggingMode = 'at_least_one_hashtag' | 'optional' | 'at_least_one_company_hashtag';
